// extracted by mini-css-extract-plugin
export default {"NotificationCenter":"NotificationCenter_NotificationCenter__Tfgzh"};